// extracted by mini-css-extract-plugin
module.exports = {"more-button":"comment-list_more-button__Map5z"};